import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  const footerYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <Container>
          <Row>
            <Col className="text-center py-3">
              <p>zpotter technologies &copy; {footerYear}</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
